<template>
  <div class="main main-really-raised w-50 ml-auto mr-auto">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="card card-signup no-shadow">
            <div class="card-header card-header-primary negative blue-grad w-50 d-flex">
              <h4 class="card-title">
                {{ $t("message.find_partner.common_info_cn") }}
              </h4>
            </div>
            <div v-if="searchComplete && !no_results" class="px-4">
              <pdf :user_id="0" :document="pdf_document" :goods="[]" :doc_id="0" source="company-info-service-cn"></pdf>
            </div>
            <div class="p-4 d-flex" style="gap: 20px">
              <input type="text" class="form-control" id="keyword" v-model="keyWord"
                :placeholder="$t('message.find_partner.search_keyword')" autocomplete="off" style="cursor: auto" />
              <button :class="[
                'btn',
                'btn-primary',
                'btn-round',
                'btn-md',
              ]" :style="{ height: 'auto', width: '200px' }" @click="searchCompanyInfo" :disabled="isSearchButtonDisabled || !keyWord" id="init_search_china">
                {{ $t("message.find_partner.search_button") }}
              </button>
            </div>
            <div class="px-4" v-if="input_error" style="color: red;">{{ $t('message.code_must_be_12_symbols') }}</div>
            <br />
            <div v-if="!searchComplete && loading > 0" style="position: relative; height: 100px">
              <div class="loading"></div>
            </div>
            <div v-if="searchComplete && !no_results" class="table-responsive">
              <div class="pl-4 pr-4 mt-n4 mb-n3">
                <search-help-text></search-help-text>
              </div>
              <div class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                <h4>{{ $t("message.find_partner.common_info_cn") }}</h4>
              </div>
              <br />
              <div class="px-4">
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">
                        {{ $t("message.find_partner.table_field") }}
                      </th>
                      <th scope="col">
                        {{ $t("message.find_partner.table_value") }}
                      </th>
                      <th scope="col">
                        {{ $t("message.find_partner.table_value_cn") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(value, index) in service_info" v-if="value[0] !== 'OperId' &&
                      value[0] !== 'KeyNo' &&
                      value[0] !== 'CreditCode' &&
                      value[0] !== 'RevokeInfo' &&
                      value[0] !== 'ParentInfo'">
                      <td style="max-width: 150px">
                        {{ $t("message.find_partner.common_info_" + value[0]) }}
                      </td>
                      <td v-if="value[0] == 'ImageUrl'">
                        <img :src="value[2]" :alt="value[2]" style="max-width: 100px" />
                      </td>
                      <td v-if="value[0] == 'ImageUrl'">
                        <img :src="value[2]" :alt="value[2]" style="max-width: 100px" />
                      </td>
                      <td v-if="value[0] == 'WebSiteUrl'">
                        <a target="_blank" :href="prepareURL(value[2])">{{
                          $t("message.find_partner.visit_company_website")
                        }}</a>
                      </td>
                      <td v-if="value[0] == 'WebSiteUrl'">
                        <a target="_blank" :href="prepareURL(value[2])">{{
                          $t("message.find_partner.visit_company_website")
                        }}</a>
                      </td>
                      <td v-if="value[0] !== 'WebSiteUrl' && value[0] !== 'ImageUrl'" style="max-width: 150px">
                        {{ value[2] }}

                        <p v-if="value[0] === 'IXCode'">
                          <br />
                          {{ $t("message.find_partner.common_info_IXCode_description") }}
                        </p>
                      </td>
                      <td v-if="value[0] !== 'WebSiteUrl' && value[0] !== 'ImageUrl'" style="max-width: 150px">
                        {{ value[1] }}
                      </td>
                    </tr>
                    <tr v-for="(value, index) in service_info" v-if="value[0] == 'CreditCode'">
                      <td style="max-width: 150px">
                        {{ $t("message.find_partner.common_info_" + value[0]) }}
                      </td>
                      <td style="max-width: 150px">{{ value[1] }}</td>
                      <td style="max-width: 150px">{{ value[1] }}</td>
                    </tr>
                  </tbody>
                </table>

                <div v-if="response_info.Area">
                  <div class="card-header card-header-primary negative rounded-0 blue-grad w-50">
                    <h4>{{ $t("message.find_partner.area_table") }}</h4>
                  </div>
                  <br />
                  <b-table :fields="object_table_fields" :items="areaList">
                    <template v-slot:cell(Key)="data">
                      {{ $t("message.find_partner.area_list_" + data.value) }}
                    </template>
                  </b-table>
                </div>

                <div v-if="response_info.Industry">
                  <div class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                    <h4>{{ $t("message.find_partner.industry_table") }}</h4>
                  </div>
                  <br />
                  <b-table :fields="object_table_fields" :items="industryList">
                    <template v-slot:cell(Key)="data">
                      {{ $t("message.find_partner.industry_list_" + data.value) }}
                    </template>
                  </b-table>
                </div>

                <div v-if="response_info.RevokeInfo">
                  <div class="card-header card-header-primary negative blue-grad w-50">
                    <h4>{{ $t("message.find_partner.revoke_info_table") }}</h4>
                  </div>
                  <br />
                  <b-table :fields="object_table_fields" :items="revokeInfoList">
                    <template v-slot:cell(Key)="data">
                      {{
                        $t("message.find_partner.revoke_info_list_" + data.value)
                      }}
                    </template>
                  </b-table>
                </div>

                <div v-if="response_info.ParentInfo">
                  <div class="card-header card-header-primary negative blue-grad w-50">
                    <h4>{{ $t("message.find_partner.parent_info_table") }}</h4>
                  </div>
                  <br />
                  <b-table :fields="object_table_fields" :items="parentInfoList">
                    <template v-slot:cell(Key)="data">
                      {{
                        $t("message.find_partner.parent_info_list_" + data.value)
                      }}
                    </template>
                  </b-table>
                </div>

                <div v-if="UsedNameList.length > 0">
                  <div class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                    <h4>
                      {{ $t("message.find_partner.common_info_name_list") }}
                    </h4>
                  </div>
                  <br />
                  <b-table :fields="used_name_list_fields" :items="UsedNameList">
                  </b-table>
                </div>

                <div v-if="ShareHolderList.length > 0">
                  <div class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                    <h4>
                      {{
                        $t("message.find_partner.common_info_share_holder_list")
                      }}
                    </h4>
                  </div>
                  <br />
                  <b-table :fields="shareholder_list_fields" :items="ShareHolderList">
                  </b-table>
                </div>

                <div v-if="EmployeeList.length > 0">
                  <div class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                    <h4>
                      {{ $t("message.find_partner.common_info_employee_list") }}
                    </h4>
                  </div>
                  <br />
                  <b-table :fields="employees_list_fields" :items="EmployeeList">
                  </b-table>
                </div>

                <div v-if="InvestList.length > 0">
                  <div class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                    <h4>
                      {{ $t("message.find_partner.common_info_invest_list") }}
                    </h4>
                  </div>
                  <br />
                  <b-table :fields="invest_list_fields" :items="InvestList">
                  </b-table>
                </div>

                <div v-if="ChangeList.length > 0">
                  <div class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                    <h4>
                      {{ $t("message.find_partner.common_info_change_list") }}
                    </h4>
                  </div>
                  <br />
                  <b-table :fields="change_list_fields" :items="ChangeList">
                  </b-table>
                </div>

                <div v-if="BranchList.length > 0">
                  <div class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                    <h4>
                      {{ $t("message.find_partner.common_info_branch_list") }}
                    </h4>
                  </div>
                  <br />
                  <b-table :fields="branch_list_fields" :items="BranchList">
                  </b-table>
                </div>

                <div v-if="MoreEmailList.length > 0">
                  <div class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                    <h4>
                      {{ $t("message.find_partner.common_info_more_email_list") }}
                    </h4>
                  </div>
                  <br />
                  <b-table :fields="more_email_list_fields" :items="MoreEmailList">
                  </b-table>
                </div>

                <div v-if="EntTagList.length > 0">
                  <div class="card-header card-header-primary negative blue-grad rounded-0 w-50">
                    <h4>
                      {{ $t("message.find_partner.common_info_ent_tag_list") }}
                    </h4>
                  </div>
                  <br />
                  <b-table :fields="ent_tag_list_fields" :items="EntTagList">
                  </b-table>
                </div>
              </div>
            </div>
            <div v-if="searchComplete && no_results">
              <div class="pl-4 mt-n4 bold text-black">
                {{
                  $t("message.find_partner.no_results_430")
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment";
export default {
  inject: ["runBiller", "updateBiller"],
  data() {
    return {
      input_error: false,
      loading: 0,
      isSearchButtonDisabled: false,
      no_results: false,
      current_tab: 0,
      response_info: {},
      service_info: {},
      service_info_objects: {},
      keyWord: "",
      searchComplete: false,
      areaSearchComplete: false,
      industrySearchComplete: false,
      revokeInfoSearchComplete: false,
      parentInfoSearchComplete: false,
      areaList: [],
      industryList: [],
      revokeInfoList: [],
      parentInfoList: [],

      UsedNameList: [],
      ShareHolderList: [],
      EmployeeList: [],
      InvestList: [],
      ChangeList: [],
      BranchList: [],
      MoreEmailList: [],
      EntTagList: [],
      pdf_document: {},
      used_name_list_fields: [
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_name_list_name"),
        },
        {
          key: "ChangeDate",
          label: this.$t("message.find_partner.common_info_name_list_date"),
        },
      ],
      shareholder_list_fields: [
        // {
        //   key: "KeyNo",
        //   label: this.$t("message.find_partner.common_info_share_holder_KeyNo"),
        // },
        {
          key: "StockName",
          label: this.$t(
            "message.find_partner.common_info_share_holder_StockName",
          ),
        },
      ],
      employees_list_fields: [
        // {
        //   key: "KeyNo",
        //   label: this.$t("message.find_partner.common_info_employee_KeyNo"),
        // },
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_employee_Name"),
        },
        {
          key: "Job",
          label: this.$t("message.find_partner.common_info_employee_Job"),
        },
      ],
      invest_list_fields: [
        // {
        //   key: "KeyNo",
        //   label: this.$t("message.find_partner.common_info_invest_list_KeyNo"),
        // },
        {
          key: "RegistCapi",
          label: this.$t(
            "message.find_partner.common_info_invest_list_RegistCapi",
          ),
        },
        {
          key: "StartDate",
          label: this.$t(
            "message.find_partner.common_info_invest_list_StartDate",
          ),
        },
        {
          key: "Status",
          label: this.$t("message.find_partner.common_info_invest_list_Status"),
        },
        {
          key: "OperName",
          label: this.$t(
            "message.find_partner.common_info_invest_list_OperName",
          ),
        },
      ],
      change_list_fields: [
        {
          key: "ProjectName",
          label: this.$t(
            "message.find_partner.common_info_change_list_ProjectName",
          ),
        },
        {
          key: "BeforeList",
          label: this.$t(
            "message.find_partner.common_info_change_list_BeforeList",
          ),
        },
        {
          key: "AfterList",
          label: this.$t(
            "message.find_partner.common_info_change_list_AfterList",
          ),
        },
        {
          key: "ChangeDate",
          label: this.$t(
            "message.find_partner.common_info_change_list_ChangeDate",
          ),
        },
      ],
      branch_list_fields: [
        {
          key: "KeyNo",
          label: this.$t("message.find_partner.common_info_branch_list_KeyNo"),
        },
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_branch_list_Name"),
        },
        {
          key: "DirectorName",
          label: this.$t(
            "message.find_partner.common_info_branch_list_DirectorName",
          ),
        },
        {
          key: "Status",
          label: this.$t("message.find_partner.common_info_branch_list_Status"),
        },
      ],
      more_email_list_fields: [
        {
          key: "Source",
          label: this.$t(
            "message.find_partner.common_info_more_email_list_Source",
          ),
        },
        {
          key: "Value",
          label: this.$t(
            "message.find_partner.common_info_more_email_list_Value",
          ),
        },
      ],
      more_tel_list_fields: [
        {
          key: "Source",
          label: this.$t(
            "message.find_partner.common_info_more_tel_list_Source",
          ),
        },
        {
          key: "Value",
          label: this.$t(
            "message.find_partner.common_info_more_tel_list_Value",
          ),
        },
      ],
      ent_tag_list_fields: [
        {
          key: "Type",
          label: this.$t("message.find_partner.common_info_ent_tag_list_Type"),
        },
        {
          key: "Name",
          label: this.$t("message.find_partner.common_info_ent_tag_list_Name"),
        },
      ],
      object_table_fields: [
        {
          key: "Key",
          label: this.$t("message.find_partner.table_field"),
        },
        {
          key: "Translated",
          label: this.$t("message.find_partner.table_value"),
        },
        {
          key: "Original",
          label: this.$t("message.find_partner.table_value_cn"),
        },
      ],
    };
  },
  mounted() { },
  computed: {},
  methods: {
    momentum(d) {
      return moment(d).format("D.MM.Y");
    },
    translateText(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        axios
          .get(
            window.base +
            "/library/TranslateNext?text=" +
            text +
            "&source=zh&target=" +
            locale,
          )
          .then((response) => {
            return response.data.translation;
          });
      } else {
        return text;
      }
    },
    translateTextArray(text) {
      var locale = this.$i18n.locale;
      switch (locale) {
        case "cn":
          locale = "zh";
          break;
        case "en":
          locale = "en";
          break;
        case "ru":
          locale = "ru";
          break;
      }
      if (locale !== "zh") {
        return axios.post(
          window.base +
          "/library/TranslateNextArray?source=zh&target=" +
          locale,
          text,
        );
      }
    },
    // formats table data with translations
    formatObjectTables(objectTranslated, objectOriginal, list, complete) {
      if (objectOriginal) {
        var keys = Object.keys(objectOriginal);
        var values = Object.values(objectOriginal);
        for (let i = 0; i < keys.length; i++) {
          list.push({
            Key: keys[i],
            Translated: objectTranslated[keys[i]],
            Original: values[i],
          });
        }
        complete = true;
        console.log("loading change", this.loading - 1);
        this.loading--;
      }
    },
    formatArrayObjectTables(object, list) {
      if (typeof object !== undefined && object && object.length > 0) {
        object.forEach((obj, i) => {
          var keys = Object.keys(obj);
          var values = Object.values(obj);
          this.translateTextArray(values)
            .then((res) => {
              var translated = {};
              for (let j = 0; j < res.data.length; j++) {
                translated[keys[j]] = JSON.parse(res.data[j]).translation;
              }
              list.push(translated);
            })
            .catch(() => {
              console.log("error translating...");
            });
        });
        console.log("loading change", this.loading - 1);
        this.loading--;
      }
    },
    resetValues() {
      this.response_info = {};
      this.service_info = {};
      this.service_info_objects = {};
      this.searchComplete = false;
      this.areaSearchComplete = false;
      this.industrySearchComplete = false;
      this.revokeInfoSearchComplete = false;
      this.parentInfoSearchComplete = false;
      this.areaList = [];
      this.industryList = [];
      this.revokeInfoList = [];
      this.parentInfoList = [];

      this.UsedNameList = [];
      this.ShareHolderList = [];
      this.EmployeeList = [];
      this.InvestList = [];
      this.ChangeList = [];
      this.BranchList = [];
      this.MoreEmailList = [];
      this.EntTagList = [];
      this.pdf_document = {};
    },
    prepareURL(string) {
      let url;
      try {
        url = new URL(string);
      } catch (_) {
        return "https://" + string;
      }
      return string;
    },
    translateStatuses(string) {
      const translations = {
        存续: this.$t("message.contragent_search.company_info_status_1"),
        开业: this.$t("message.contragent_search.company_info_status_1"),
        在业: this.$t("message.contragent_search.company_info_status_1"),
        在营: this.$t("message.contragent_search.company_info_status_1"),
        正常: this.$t("message.contragent_search.company_info_status_1"),
        经营: this.$t("message.contragent_search.company_info_status_1"),
        在册: this.$t("message.contragent_search.company_info_status_1"),
        在营在册: this.$t("message.contragent_search.company_info_status_1"),
        有效: this.$t("message.contragent_search.company_info_status_1"),
        在业在册: this.$t("message.contragent_search.company_info_status_1"),
        迁出: this.$t("message.contragent_search.company_info_status_2"),
        吊销: this.$t("message.contragent_search.company_info_status_3"),
        未注销: this.$t("message.contragent_search.company_info_status_3"),
        注销: this.$t("message.contragent_search.company_info_status_4"),
        停业: this.$t("message.contragent_search.company_info_status_5"),
        清算: this.$t("message.contragent_search.company_info_status_6"),
        "、": ", ",
      };
      for (const key in translations) {
        let value = translations[key];
        string = string.replaceAll(key, value);
      }
      return string;
    },

    validateKeyWord() {
      if (!isNaN(Number(this.keyWord)) && ![15, 18].includes(this.keyWord.length)) {
        this.input_error = true;
        return false;
      }
      this.input_error = false;
      return true;
    },

    disableSearchForSomeTime() {
      new Noty({
        type: "success",
        theme: "light",
        text: this.$t("message.request_processing"),
        timeout: 5000,
        progressBar: true,
      }).show();
      this.isSearchButtonDisabled = true;
      setTimeout(() => {
        this.isSearchButtonDisabled = false;
      }, 20000);
    },

    async searchCompanyInfo() {
      if (!this.validateKeyWord()) {
        return;
      }

      const reduceBalanceId = await this.runBiller("430", this.keyWord, false);

      if (!reduceBalanceId) {
        return;
      }

      this.disableSearchForSomeTime();
      this.loading = 14;
      this.searchComplete = false;

      axios.get(window.base + "/library/OpenApiQccFull", {
        params: {
          keyWord: this.keyWord,
          signalRConnectionId: window.signalRConnectionId
        }
      })
        .then((response) => {
          this.resetValues();
          this.loading--;
          if (!response.data || response.data.ErrorMessage || !JSON.parse(response.data.OriginalJson).Result) {
            this.searchComplete = true;
            this.loading = 0;
            this.no_results = true;
            // this.updateBiller(reduceBalanceId, false);
            return;
          }

          var originalResponse = JSON.parse(response.data.OriginalJson);
          var translatedResponse = JSON.parse(response.data.TranslatedJson);

          // this.updateBiller(reduceBalanceId, true);
          this.no_results = false;
          var tmp_response_info = translatedResponse.Result;
          var tmp_response_info_original = originalResponse.Result;

          // transform change list data
          if (tmp_response_info.ChangeList.length > 0) {
            tmp_response_info.ChangeList.forEach((chg) => {
              chg.BeforeList = chg.BeforeList.join(",");
              chg.AfterList = chg.AfterList.join(",");
            });
          }

          var tmp_service_info = Object.entries(originalResponse.Result);
          //var tmp_service_info_objects = tmp_service_info.filter(item => typeof item[1] === 'object' && item[1] !== null && !_.isArray(item[1]));
          tmp_service_info = tmp_service_info.filter(
            (item) =>
              typeof item[1] !== "object" && !_.isArray(item[1]),
          );

          // Translating packages of text (columns of tables)
          var service_to_translate = [];
          tmp_service_info.forEach(([key, value]) => {
            service_to_translate.push(value);
          });

          this.loading--;
          this.searchComplete = true;
          for (let i = 0; i < tmp_service_info.length; i++) {
            tmp_service_info[i].push(tmp_response_info[tmp_service_info[i][0]]);
          }
          this.service_info = tmp_service_info;
          this.pdf_document.service_info = this.service_info;

          this.pdf_document.service_info = this.pdf_document.service_info.map((item) => {
            if (item[0] == "Status") {
              item[2] = this.translateStatuses(item[1]);
            }
            return item;
          });

          //Formating object tables data
          this.formatObjectTables(
            tmp_response_info.Area,
            tmp_response_info_original.Area,
            this.areaList,
            this.areaSearchComplete,
          );
          this.formatObjectTables(
            tmp_response_info.Industry,
            tmp_response_info_original.Industry,
            this.industryList,
            this.industrySearchComplete,
          );
          this.formatObjectTables(
            tmp_response_info.RevokeInfo,
            tmp_response_info_original.RevokeInfo,
            this.revokeInfoList,
            this.revokeInfoSearchComplete,
          );
          this.formatObjectTables(
            tmp_response_info.ParentInfo,
            tmp_response_info_original.ParentInfo,
            this.parentInfoList,
            this.parentInfoSearchComplete,
          );

          //Formating object array tables
          this.EntTagList = tmp_response_info.EntTagList;
          this.ChangeList = tmp_response_info.ChangeList;
          this.UsedNameList = tmp_response_info.UsedNameList;
          this.ShareHolderList = tmp_response_info.ShareHolderList;
          this.EmployeeList = tmp_response_info.EmployeeList;
          this.InvestList = tmp_response_info.InvestList;
          this.BranchList = tmp_response_info.BranchList;
          this.MoreEmailList = tmp_response_info.MoreEmailList;
          this.response_info = tmp_response_info;

          // adding data for pdf
          this.pdf_document.response_info = tmp_response_info;
          this.pdf_document.service_info =
            this.service_info || tmp_service_info;
          this.pdf_document.areaList = this.areaList;
          this.pdf_document.industryList = this.industryList;
          this.pdf_document.revokeInfoList = this.revokeInfoList;
          this.pdf_document.parentInfoList = this.parentInfoList;
          this.pdf_document.EntTagList = this.EntTagList;
          this.pdf_document.ChangeList = this.ChangeList;
          this.pdf_document.UsedNameList = this.UsedNameList;
          this.pdf_document.ShareHolderList = this.ShareHolderList;
          this.pdf_document.EmployeeList = this.EmployeeList;
          this.pdf_document.InvestList = this.InvestList;
          this.pdf_document.BranchList = this.BranchList;
          this.pdf_document.MoreEmailList = this.MoreEmailList;
        })
        .catch((error) => {
          if (error.message === 'Network Error') {
            new Noty({
              theme: "light",
              type: "error",
              text: this.$t("message.request_error_messages.connection_issue"),
              timeout: 5000,
            }).show();
          }
          console.log(error);
          this.searchComplete = true;
          this.loading = 0;
          this.no_results = true;
          // this.updateBiller(reduceBalanceId, false);
        })
    },
  },
  watch: {
    keyWord(newValue) {
      this.input_error = false;
    },
  },
};
</script>
